module.exports = __webpack_public_path__ + "static/B2-8e63cb6ffb2a9503bae9372797cb6805.jpg";